import * as React from 'react';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { DismissingCardContext } from './DismissingCardContext.js';
import { CircleDismissButton as CircleDismissButton$1 } from './styles.js';
import { Close } from '../Icons/components/Close.js';

const CircleDismissButton = ({ className , position  })=>{
    const { dismiss  } = useContext(DismissingCardContext);
    const theme = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(CircleDismissButton$1, {
        small: true,
        onClick: dismiss,
        "aria-label": "Dismiss",
        className: className,
        icon: /*#__PURE__*/ React.createElement(Close, {
            color: theme.colors["Level 5"]
        }),
        $position: position
    });
};

export { CircleDismissButton };
